import React, { useRef, useEffect } from 'react';
import './NotificationPopup.css';
import { X } from 'lucide-react';

const NotificationItem = ({ title, description, time, image, isNew }) => {
  return (
    <div className={`notification-item ${isNew ? 'notification-new' : ''}`}>
      {image && <img src={image} alt={title} className="notification-image" />}
      <div className="notification-content">
        <div className="notification-header">
          <h3 className="notification-title">{title}</h3>
          {isNew && <span className="notification-badge">New</span>}
        </div>
        <p className="notification-description">{description}</p>
        <span className="notification-time">{time}</span>
      </div>
    </div>
  );
};

const NotificationPopup = ({ isOpen, onClose }) => {
  const popupRef = useRef(null);

  // Sample notification data based on the image
  const notifications = [
    {
      title: "You now have access to Studio, our longform editor",
      description: "A powerful suite of tools designed to help creators and storytellers bring their audiobooks, voiceovers and narrations to life.",
      time: "3 months ago",
      image: "/image/guy10.jpeg", 
      isNew: false
    },
    {
      title: "Meet Flash",
      description: "Our newest model that generates speech in 75ms + application & network latency. You've never experienced human-like TTS this fast.",
      time: "5 months ago",
      image: "/image/lady15.jpeg", 
      isNew: false
    },
    {
      title: "Introducing Conversational AI",
      description: "Build customizable, interactive voice agents in minutes not months. Low latency, configurable and scalable.",
      time: "5 months ago",
      image: "/image/lady12.jpeg", 
      isNew: false
    },
    {
      title: "Introducing Conversational AI",
      description: "Build customizable, interactive voice agents in minutes not months. Low latency, configurable and scalable.",
      time: "5 months ago",
      image: "/image/lady17.jpeg", 
      isNew: false
    },
  ];

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="notification-popup-overlay">
      <div className="notification-popup" ref={popupRef}>
        <div className="notification-header-bar">
          <h2>Notifications</h2>
          <button className="notification-close-btn" onClick={onClose}>
            <X size={18} />
          </button>
        </div>
        
        <div className="notification-list">
          {notifications.map((notification, index) => (
            <NotificationItem 
              key={index}
              title={notification.title}
              description={notification.description}
              time={notification.time}
              image={notification.image}
              isNew={notification.isNew}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotificationPopup;